import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FacilityState {
  tenant: IFacility | null;
}

const initialState: FacilityState = {
  tenant: (() => {
    try {
      const faciLocal = localStorage.getItem('tenant');
      return faciLocal ? JSON.parse(faciLocal) : null;
    } catch {
      return null;
    }
  })(),
};

const facilitySlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setFacility(state, action: PayloadAction<IFacility | null>) {
      state.tenant = action.payload;
      if (action.payload) {
        localStorage.setItem('tenant', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('tenant');
      }
    },
  },
});

export const { setFacility } = facilitySlice.actions;
export default facilitySlice.reducer;
